import LoadingComponent from "./LoadingComponent";

const LoadingPage = () => {
  return <LoadingComponent />;
};

export default LoadingPage;
